import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';

const useStyles = makeStyles(theme => ({

    primaryLight: {
        backgroundColor: theme.palette.primary.light,
        color: '#000',
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        }
    },

}))

export const FingotiSwitchButton = ({ leftText, rightText, onClick, value }) => {

    const classes = useStyles();

    return (
        <ButtonGroup color="primary">
            <Button 
                disableElevation 
                onClick={() => onClick(false)} 
                className={!value && classes.primaryLight} 
                variant={!value ? "contained" : "outlined"}
            >
                {leftText}
            </Button>
            <Button 
                disableElevation
                onClick={() => onClick(true)}
                className={value && classes.primaryLight} 
                variant={value ? "contained" : "outlined"}
            >
                {rightText}
            </Button>
        </ButtonGroup>
    );

}

FingotiSwitchButton.defaultProps = {
    leftTest: "",
    rightText: "",
    onClick: () => {},
    value: false,
}

FingotiSwitchButton.propTypes = {
    leftTest: PropTypes.string,
    rightText: PropTypes.string,
    onClick: PropTypes.func,
    value: PropTypes.bool,
}